class UrlUtility {
    static getQueryString = () => {
        if(typeof window !== 'undefined'){
            var hrefSplit = window.location.href.split('?');

            if (hrefSplit.length > 1) {
                return decodeURIComponent(hrefSplit[1]);
            }

        }
        return "";
    }

    static getQueryParams = () => {
        var paramObject = {

        };
        var queryString = UrlUtility.getQueryString();
        var queryStringSplit = queryString.split('&');

        queryStringSplit.forEach(keyValue => {
            var keyValueSplit = keyValue.split('=');
            var key = keyValueSplit[0];
            var value = keyValueSplit[1];

            paramObject[key] = value;
        })

        return paramObject;
    }

    static getValue(key) {
        key = key.toLowerCase();
        var paramsObject = UrlUtility.getQueryParams();

        for (let property in paramsObject) {
            if (paramsObject.hasOwnProperty(property)) {
                property = property.toLowerCase();

                if (key == property) {
                    return paramsObject[key];
                }
            }
        }
    }

    static buildQueryString = (queryParamObject) => {
        var queryString = [];

        for (var property in queryParamObject) {
            if (queryParamObject.hasOwnProperty(property)) {
                var value = queryParamObject[property];

                queryString.push(`${property}=${value}`);
            }
        }

        return "?" + encodeURIComponent(queryString.join('&'));
    }

    static sanitizeUrl = (url) => {
        var cleanedSlashes = url.replace(new RegExp("//", "g"), "/").replace(":/", "://");
        var cleanedQuestionMarks = cleanedSlashes.replace(new RegExp("\\?", "?"));

        return cleanedQuestionMarks;
    }
};

export default UrlUtility;


// WEBPACK FOOTER //
// ./src/utils/UrlUtility.js